import { useTranslation } from 'react-i18next';
import * as v from 'valibot';
export function useContentSchema() {
    const { t } = useTranslation();
    const schema = v.looseObject({
        name: v.pipe(v.string(), v.nonEmpty(t('general.input_error.required')))
    });
    return schema;
}
